import { Component } from '@angular/core';

@Component({
    templateUrl: './not-yet-implemented.template.html',
    styleUrls: ['./not-yet-implemented.style.scss']
})
export class NotYetImplementedComponent { }